import { formatRub } from '../lib/calcCost'
import styles from './CostTotals.module.css'

interface CostTotalsProps {
  total: number
  /** Сколько строк реально посчитано — остальные ещё не заполнены. */
  counted: number
  totalRows: number
}

/**
 * Итог расчёта. Отдельно подсказываем, сколько строк учтено: иначе непонятно,
 * почему сумма меньше ожидаемой, когда часть полей пустая.
 */
export const CostTotals = ({ total, counted, totalRows }: CostTotalsProps) => {
  const skipped = totalRows - counted
  return (
    <div className={styles.totals}>
      <div className={styles.row}>
        <span className={styles.label}>Себестоимость</span>
        <span className={styles.value}>{formatRub(total)}</span>
      </div>
      {skipped > 0 && (
        <p className={styles.hint}>
          {skipped === 1
            ? 'Одна строка не заполнена до конца и в сумму не вошла.'
            : `Строк не заполнено до конца: ${skipped} — они в сумму не вошли.`}
        </p>
      )}
    </div>
  )
}
